import { library } from "@fortawesome/fontawesome-svg-core";
import { faArchive, faBan, faChartLine, faCircleNotch, faCloud, faKey, faPlug, faRecycle, faShieldAlt, faTachometerAlt, faUserLock, } from "@fortawesome/free-solid-svg-icons";
library.add(faUserLock, faChartLine, faBan, faCircleNotch, faPlug, faTachometerAlt, faArchive, faRecycle, faKey, faShieldAlt, faCloud);
